module.exports = __webpack_public_path__ + "img/1.4b9fbd4a.png";